import React, { useEffect } from "react";

function App() {
  useEffect(() => {
    // Redirect all traffic to the admin dashboard
    window.location.replace('/admin/index.html');
  }, []);

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      backgroundColor: '#f9fafb',
      fontFamily: 'Georgia, serif'
    }}>
      <p style={{ color: '#6b7280', fontSize: '14px' }}>Redirecting to trove helix...</p>
    </div>
  );
}

export default App;
